<tabset [justified]="true">
  <tab heading="Justified">Justified content</tab>
  <tab heading="SJ">Short Labeled Justified content</tab>
  <tab heading="Long Justified">Long Labeled Justified content</tab>
</tabset>
